import { formatCount } from '@/shared/lib';
import { Button } from '@/shared/ui';

interface PagerProps {
  pageNumber: number;
  totalPages: number;
  totalCount: number;
  /** The count (and so the page count) is an estimate from table metadata. */
  estimate?: boolean;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

/** Previous / page / next controls for server-paged explorer tables. */
export function Pager({
  pageNumber,
  totalPages,
  totalCount,
  estimate = false,
  onPageChange,
  disabled = false,
}: PagerProps) {
  const approx = estimate ? '≈ ' : '';
  return (
    <nav className="toolbar" aria-label="Pagination">
      <Button
        variant="link"
        disabled={disabled || pageNumber <= 1}
        onClick={() => {
          onPageChange(pageNumber - 1);
        }}
      >
        Previous
      </Button>
      <span className="muted" aria-live="polite">
        Page {formatCount(pageNumber)} of {approx}
        {formatCount(Math.max(1, totalPages))} · {approx}
        {formatCount(totalCount)} {totalCount === 1 ? 'record' : 'records'}
      </span>
      <Button
        variant="link"
        disabled={disabled || pageNumber >= totalPages}
        onClick={() => {
          onPageChange(pageNumber + 1);
        }}
      >
        Next
      </Button>
    </nav>
  );
}
